import React from 'react';
import { motion } from 'framer-motion';
import { fadeUpVariants, staggerContainerVariants } from './useScrollReveal';

const stats = [
  { num: '50+', label: 'Projects Completed' },
  { num: '4.9★', label: 'Client Rating' },
  { num: '100%', label: 'Satisfaction Rate' },
  { num: '3×', label: 'Avg. Growth' },
];

const Mission: React.FC = () => {
  return (
    <section id="mission" className="py-32 bg-[#080808] border-t border-[#0f0f0f]">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-20 items-center">
          {/* Left */}
          <motion.div
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            variants={staggerContainerVariants}
          >
            <motion.p variants={fadeUpVariants} className="section-label mb-6">Our Mission</motion.p>
            <motion.h2
              variants={fadeUpVariants}
              className="font-serif text-[clamp(2rem,4.5vw,3.8rem)] text-white leading-tight mb-8"
            >
              We Drive Small Businesses To The Forefront Of Their{' '}
              <span className="italic text-lime">Industries.</span>
            </motion.h2>
            <motion.p variants={fadeUpVariants} className="font-dm text-[#aaa] text-base leading-relaxed mb-5">
              First impressions matter more than ever. That's why our mission is to create clean, enduring digital presences that elevate small businesses to compete at the highest level.
            </motion.p>
            <motion.p variants={fadeUpVariants} className="font-dm text-[#999] text-base leading-relaxed mb-10">
              Whether it's a stunning website, a bold brand identity, or compelling photo and video — we deliver the full picture, with the care and attention your business deserves.
            </motion.p>
            <motion.div variants={fadeUpVariants} className="flex items-center gap-3 mb-10 p-5 border border-[#141414] rounded-xl bg-[#0a0a0a]">
              <div className="w-px h-10 bg-lime flex-shrink-0" />
              <p className="font-dm text-[#aaa] text-sm leading-relaxed">
                <span className="text-white font-syne font-semibold">We work with all budgets.</span>{' '}
                No business is too small — we'll find a solution that works for you.
              </p>
            </motion.div>
            <motion.div variants={fadeUpVariants}>
              <a href="#contact" className="btn-lime px-8 py-4 text-sm">Book A Call</a>
            </motion.div>
          </motion.div>

          {/* Right — stat grid */}
          <motion.div
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            variants={staggerContainerVariants}
            className="grid grid-cols-2 gap-4"
          >
            {stats.map((s, i) => (
              <motion.div
                key={s.label}
                variants={fadeUpVariants}
                className="group border border-[#141414] rounded-2xl p-8 flex flex-col justify-between min-h-[170px] relative overflow-hidden cursor-default"
                whileHover={{ borderColor: '#C8F13530', y: -4 }}
                transition={{ duration: 0.25 }}
              >
                <div
                  className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-500"
                  style={{ background: 'radial-gradient(circle at 30% 30%, rgba(200,241,53,0.04), transparent 60%)' }}
                />
                <span className="font-serif text-[clamp(2.5rem,4vw,3.5rem)] text-white leading-none relative z-10 group-hover:text-lime transition-colors duration-300">
                  {s.num}
                </span>
                <span className="font-dm text-[#999] text-sm relative z-10">{s.label}</span>
              </motion.div>
            ))}
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Mission;
